/* eslint-disable */
import { Box, Modal, Paper, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import styles from "./DiscountInfoModal.module.scss";
import {
  getBaseCurrencyBySwitchDate,
  getCurrencySymbol,
} from "../../../utils/currency";

const DiscountInfoModal = ({ open, handleClose, type, discount }) => {
  const { t } = useTranslation();
  const fixedDiscountCurrencySymbol = getCurrencySymbol(getBaseCurrencyBySwitchDate());
  return (
    <Paper className={styles["discount-info-modal"]}>
      <div className={styles["discount-info-heading-container"]}>
        <h3>{t("modals:discountInfo")}</h3>
        <p onClick={handleClose} style={{ cursor: "pointer" }}>
          {t("hide")} {`>`}
        </p>
      </div>
      <div className={styles["activity-window"]}>
        <div className={styles.activity}>
          <p>{t("modals:promoCode")}</p>
          <h4 style={{ marginTop: "1%" }}>{discount?.discountCode}</h4>
        </div>
        <div className={styles.activity}>
          <p>{t("modals:policyType")}</p>
          <h4 style={{ marginTop: "1%" }}>{discount?.policyType}</h4>
        </div>
        <div className={styles.activity}>
          <p>{t("modals:discountInPercent")}</p>
          <h4 style={{ marginTop: "1%" }}>{discount?.discountCampaign?.discountInPercent === true ? t("yes") : t("no")}</h4>
        </div>
        {discount?.discountCampaign?.customDiscounts?.map((disc, i) => {
          return (
            <div className={styles.activity} key={i}>
              <p>{t("modals:discountN", { n: i + 1 })}</p>
              <h4 style={{ marginTop: "1%" }}>
                {t("modals:policyLabel")} {disc?.policyType}{" "}
                {disc?.genericDiscount &&
                  `- ${disc?.discount} ${
                    discount?.discountCampaign?.discountInPercent === true
                      ? "%"
                      : fixedDiscountCurrencySymbol
                  }`}
              </h4>
              <div style={{ marginTop: "1%" }}>
                {disc?.customDiscountsPerInsuranceAgency?.map((disc) => {
                  return (
                    <p style={{ display: "flex" }} key={disc?.insuranceAgencyName}>
                      {disc?.insuranceAgencyName} - {disc?.discount}
                    </p>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </Paper>
  );
};

export default DiscountInfoModal;
